import {makePing} from "../interaction/interaction.js"

export function ping() {
  return makePing
}
